//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/VehiclePropConfig.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VehicleAreaConfig } from "./VehicleAreaConfig_pb";
import { file_android_hardware_automotive_vehicle_VehicleAreaConfig } from "./VehicleAreaConfig_pb";
import type { VehiclePropertyAccess } from "./VehiclePropertyAccess_pb";
import { file_android_hardware_automotive_vehicle_VehiclePropertyAccess } from "./VehiclePropertyAccess_pb";
import type { VehiclePropertyChangeMode } from "./VehiclePropertyChangeMode_pb";
import { file_android_hardware_automotive_vehicle_VehiclePropertyChangeMode } from "./VehiclePropertyChangeMode_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/VehiclePropConfig.proto.
 */
export const file_android_hardware_automotive_vehicle_VehiclePropConfig: GenFile = /*@__PURE__*/
  fileDesc("CjthbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9WZWhpY2xlUHJvcENvbmZpZy5wcm90bxIpYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8igQMKEVZlaGljbGVQcm9wQ29uZmlnEgwKBHByb3AYASABKAUSUAoGYWNjZXNzGAIgASgOMkAuYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8uVmVoaWNsZVByb3BlcnR5QWNjZXNzElkKC2NoYW5nZV9tb2RlGAMgASgOMkQuYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8uVmVoaWNsZVByb3BlcnR5Q2hhbmdlTW9kZRJSCgxhcmVhX2NvbmZpZ3MYBCADKAsyPC5hbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90by5WZWhpY2xlQXJlYUNvbmZpZxIUCgxjb25maWdfYXJyYXkYBSADKAUSFQoNY29uZmlnX3N0cmluZxgGIAEoDBIXCg9taW5fc2FtcGxlX3JhdGUYByABKAISFwoPbWF4X3NhbXBsZV9yYXRlGAggASgCYgZwcm90bzM", [file_android_hardware_automotive_vehicle_VehicleAreaConfig, file_android_hardware_automotive_vehicle_VehiclePropertyAccess, file_android_hardware_automotive_vehicle_VehiclePropertyChangeMode]);

/**
 * Must be in sync with VehiclePropConfig.aidl. 
 *
 * @generated from message android.hardware.automotive.vehicle.proto.VehiclePropConfig
 */
export type VehiclePropConfig = Message<"android.hardware.automotive.vehicle.proto.VehiclePropConfig"> & {
  /**
   * Property identifier 
   *
   * @generated from field: int32 prop = 1;
   */
  prop: number;

  /**
   * Defines if the property is read or write or both. 
   *
   * @generated from field: android.hardware.automotive.vehicle.proto.VehiclePropertyAccess access = 2;
   */
  access: VehiclePropertyAccess;

  /**
   * Defines the change mode of the property. 
   *
   * @generated from field: android.hardware.automotive.vehicle.proto.VehiclePropertyChangeMode change_mode = 3;
   */
  changeMode: VehiclePropertyChangeMode;

  /**
   * Contains per-area configuration. 
   *
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.VehicleAreaConfig area_configs = 4;
   */
  areaConfigs: VehicleAreaConfig[];

  /**
   * Contains additional configuration parameters 
   *
   * @generated from field: repeated int32 config_array = 5;
   */
  configArray: number[];

  /**
   * Some properties may require additional information passed over this
   * string. Most properties do not need to set this. 
   *
   * @generated from field: bytes config_string = 6;
   */
  configString: Uint8Array;

  /**
   * Min sample rate in Hz.
   * Must be defined for VehiclePropertyChangeMode::CONTINUOUS 
   *
   * @generated from field: float min_sample_rate = 7;
   */
  minSampleRate: number;

  /**
   * Must be defined for VehiclePropertyChangeMode::CONTINUOUS
   * Max sample rate in Hz. 
   *
   * @generated from field: float max_sample_rate = 8;
   */
  maxSampleRate: number;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.VehiclePropConfig.
 * Use `create(VehiclePropConfigSchema)` to create a new message.
 */
export const VehiclePropConfigSchema: GenMessage<VehiclePropConfig> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropConfig, 0);

